module.exports = __webpack_public_path__ + "img/mail_error.f25a543e.png";